import { CHANGE_PLANS_TAB } from '../actions';
import { PLAN_TABS } from '../constants';

const initialState = PLAN_TABS.ALL;

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case CHANGE_PLANS_TAB:
      return payload;
    default:
      return state;
  }
};
